import { Building2, Plus, RefreshCw } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import type { BrandSummary } from "../../shared/types";
import { api } from "../api";
import { productionLanguageLabel } from "../../shared/brandProduction";
import { CopyablePublicId } from "../components/CopyablePublicId";
import { AddBrandForm } from "../components/AddBrandForm";

export function BrandsPage() {
  const [brands, setBrands] = useState<BrandSummary[] | null>(null);
  const [error, setError] = useState("");
  const [adding, setAdding] = useState(false);
  const addButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    void api.brands().then((value) => setBrands(value.items)).catch((reason) => setError(reason instanceof Error ? reason.message : "Could not load brands"));
  }, []);

  return <div className="brands-page">
    <header className="library-heading"><div><span className="eyebrow">Brand intelligence</span><h1>Brands</h1></div><div className="brand-heading-actions"><p>{brands ? `${brands.length} brands` : "Loading brands"}</p><button ref={addButton} className="primary-button" disabled={adding} aria-expanded={adding} aria-controls="add-brand-form" onClick={() => setAdding(true)}><Plus size={16} aria-hidden="true" />Add brand</button></div></header>
    {adding && <AddBrandForm onClose={() => { setAdding(false); requestAnimationFrame(() => addButton.current?.focus()); }} />}
    {error && <div className="error-banner" role="alert"><div><strong>Brands unavailable</strong><p>{error}</p></div><button onClick={() => window.location.reload()}><RefreshCw size={16} />Try again</button></div>}
    {!brands && !error && <div className="brand-grid" aria-label="Loading brands">{Array.from({ length: 8 }).map((_, index) => <div className="brand-skeleton" key={index} />)}</div>}
    {brands && <div className="brand-grid">{brands.map((brand) => <article className="brand-card" key={brand.slug}>
      <Link to={`/brands/${brand.slug}`} className="brand-card__link" aria-label={`Open ${brand.name}`}>
        <div className="brand-card__hero"><img src={brand.heroPath} alt="" onError={(event) => { event.currentTarget.hidden = true; }} /><span><Building2 size={32} /></span></div>
        <div className="brand-card__body"><h2>{brand.name}</h2><div>{brand.isClient && <span className="brand-client-label">Client · {productionLanguageLabel(brand.productionLanguage)}</span>}<p>{brand.adCount} {brand.adCount === 1 ? "ad" : "ads"}</p></div></div>
      </Link>
      <CopyablePublicId value={brand.publicId} label="Brand ID" className="brand-card__id" />
    </article>)}</div>}
  </div>;
}
